var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrematureWithdrawal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 17.5H13C12.1716 17.5 11.5 18.1716 11.5 19V22C11.5 22.8284 12.1716 23.5 13 23.5H37C37.8284 23.5 38.5 22.8284 38.5 22V19C38.5 18.1716 37.8284 17.5 37 17.5Z",
    stroke: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 19.25H15.5C15.3619 19.25 15.25 19.3619 15.25 19.5C15.25 19.6381 15.3619 19.75 15.5 19.75H34.5C34.6381 19.75 34.75 19.6381 34.75 19.5C34.75 19.3619 34.6381 19.25 34.5 19.25Z",
    stroke: "#183883",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 19.5H21C20.1716 19.5 19.5 20.1716 19.5 21V34C19.5 34.8284 20.1716 35.5 21 35.5H30C30.8284 35.5 31.5 34.8284 31.5 34V21C31.5 20.1716 30.8284 19.5 30 19.5Z",
    fill: "white",
    stroke: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4063 26.9258L28.1992 27.6133H23.2852L23.4883 26.9258H28.4063ZM26.418 33L23.3477 29.3945L23.3398 28.8906H24.6836C25.0898 28.8906 25.4362 28.832 25.7227 28.7148C26.0091 28.5951 26.2279 28.418 26.3789 28.1836C26.5326 27.9492 26.6094 27.6589 26.6094 27.3125C26.6094 26.8021 26.4492 26.401 26.1289 26.1094C25.8112 25.8151 25.3555 25.668 24.7617 25.668H23.2852L23.4883 25H24.7617C25.3346 25 25.8138 25.099 26.1992 25.2969C26.5872 25.4948 26.8789 25.7682 27.0742 26.1172C27.2721 26.4635 27.3711 26.862 27.3711 27.3125C27.3711 27.7344 27.276 28.1146 27.0859 28.4531C26.8984 28.7891 26.6081 29.056 26.2148 29.2539C25.8242 29.4492 25.3255 29.5469 24.7188 29.5469H24.4375L27.3281 32.9414V33H26.418ZM28.4336 25L28.2305 25.6875L24.0898 25.668L24.2773 25H28.4336Z",
    fill: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 49.5C38.531 49.5 49.5 38.531 49.5 25C49.5 11.469 38.531 0.5 25 0.5C11.469 0.5 0.5 11.469 0.5 25C0.5 38.531 11.469 49.5 25 49.5Z",
    stroke: "#183883"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrematureWithdrawal);
export default __webpack_public_path__ + "static/media/PrematureWithdrawal.4ede228500145370deb4087e07369ae7.svg";
export { ForwardRef as ReactComponent };